import { render, staticRenderFns } from "./RazredLekcije.vue?vue&type=template&id=7511cd66&"
import script from "./RazredLekcije.vue?vue&type=script&lang=js&"
export * from "./RazredLekcije.vue?vue&type=script&lang=js&"
import style0 from "./RazredLekcije.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports